import { permissoes, routesNames } from '@/core/constants'
import ModeloDocumento from '@/views/pages/configuracao/modelo-documento/ModeloDocumento.vue'
import Configuracao from '@/views/pages/configuracao/Configuracao.vue'
import Fiscais from '@/views/pages/configuracao/fiscais/Fiscais.vue'
import RedirecionaEditarUsuario from "@/views/pages/comum/perfil/RedirecionaEditarUsuario.vue";
import Revisoes from '@/views/pages/configuracao/revisoes/Revisoes.vue'
import RevisaoCriacao from '@/views/pages/configuracao/revisoes/criacao/RevisaoCriacao.vue'
import RevisaoEdicao from '@/views/pages/configuracao/revisoes/edicao/RevisaoEdicao.vue'
import RevisaoVisualizacao from '@/views/pages/configuracao/revisoes/visualizacao/RevisaoVisualizacao.vue'
import TipoDocumento from '@/views/pages/configuracao/tipo-documento/TipoDocumento.vue'

export default [
	{
		name: routesNames.CONFIGURACAO.CONFIGURACAO_VIEW,
		path: '/configuracao',
		component: Configuracao,
		meta: {
			menu: {
				title: 'Configurações',
				icon: 'settings',
			},
			page: {
				title: 'Configurações',
			},
			requiresAuth: true,
			authorities: [permissoes.configuracoesMenu],
		},
		children: [
			{
				name: routesNames.CONFIGURACAO.MODELO_DOCUMENTO_VIEW,
				path: '/modelos-documento',
				component: ModeloDocumento,
				meta: {
					menu: {
						title: 'Modelos Documentos',
					},
					page: {
						title: 'Modelos Documentos',
						subtitle: 'Listagem geral de modelos de documentos',
					},
					requiresAuth: true,
					authorities: [permissoes.modeloDocumentoMenu],
				},
			},
			{
				name: routesNames.CONFIGURACAO.MODELO_DOCUMENTO_VIEW,
				path: '/tipos-documento',
				component: TipoDocumento,
				meta: {
					menu: {
						title: 'Tipos Documentos',
					},
					page: {
						title: 'Tipos Documentos',
						subtitle: 'Listagem geral de tipos de documentos',
					},
					requiresAuth: true,
					authorities: [permissoes.tipoDocumentoMenu],
				},
			},
			{
				name: routesNames.CONFIGURACAO.FISCAIS_VIEW,
				path: '/fiscais',
				component: Fiscais,
				meta: {
					menu: {
						title: 'Fiscais',
					},
					page: {
						title: 'Fiscais',
						subtitle: 'Listagem geral de fiscais',
					},
					requiresAuth: true,
					authorities: [permissoes.fiscaisMenu],
				},
			},
			{
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_VIEW,
				path: '/revisoes',
				component: Revisoes,
				meta: {
					menu: {
						title: 'Revisões',
					},
					page: {
						title: 'Revisões',
						subtitle: 'Listagem geral de revisões',
					},
					requiresAuth: true,
					authorities: [permissoes.revisoesListar]
				},
			},
			{
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_CRIACAO_VIEW,
				path: '/revisoes/criacao',
				component: RevisaoCriacao,
				meta: {
					page: {
						title: 'Revisões',
						subtitle: 'Nova configuração de revisão',
					},
					requiresAuth: true,
					authorities: [permissoes.revisoesCriar]
				}
			},
			{
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_EDICAO_VIEW,
				path: '/revisoes/:id/edicao',
				component: RevisaoEdicao,
				meta: {
					page: {
						title: 'Revisões',
						subtitle: 'Editar configuração de revisão',
					},
					requiresAuth: true,
					authorities: [permissoes.revisoesEditar],
				}
			},
			{
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_VISUALIZACAO_VIEW,
				path: '/revisoes/:id/visualizacao',
				component: RevisaoVisualizacao,
				meta: {
					page: {
						title: 'Revisões',
						subtitle: 'Visualizar configuração de revisão',
					},
					requiresAuth: true,
					authorities: [permissoes.revisoesVisualizar],
				}
			},
			{
				name: routesNames.REDIRECIONAR_EDITAR_USUARIO,
				path: '/perfil',
				component: RedirecionaEditarUsuario,
				meta: {
					page: {
						title: 'Redirecionando para seu perfil',
					},
				},
			},
		],
	},
]
